import { useCallback } from 'react';
import { Flex, List, Text } from '@leverege/ui-elements';
import { useWizard } from '@leverege/ui-wizard';
import I18N from '@leverege/i18n';
import { Config } from '@leverege/plugin';
import S from './TagPairingSelectionRenderer.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('pairing.imagine.PairingSelectionRenderer');
function TagPairingSelectionRenderer(props) {
  const {
    item: tag,
    name,
    onChange: pOnChange,
    eventData
  } = props;
  const {
    context,
    setActiveStep
  } = useWizard();
  const {
    parentAttribute,
    relationship
  } = context;
  const assetId = parentAttribute.get(tag);
  function isTagUnactivated(tag) {
    const tagOfflineWindow = Config.get('Pairing', 'tagOfflineWindow', 1000 * 60 * 10);
    const lastHeartbeat = tag?.data?.lastHeartbeat;
    return !lastHeartbeat || lastHeartbeat < Date.now() - tagOfflineWindow;
  }
  function isTagLowBattery(tag) {
    const batteryLevel = tag?.data?.batteryLevel;
    return batteryLevel && batteryLevel < 50;
  }
  const onClick = useCallback(({
    item
  }) => {
    const evt = {
      data: eventData,
      value: item
    };
    try {
      // Check if tag is unactivated
      const isUnactivated = isTagUnactivated(tag);
      if (isUnactivated) {
        setActiveStep('tagUnactivated');
        return;
      }

      // Check if tag has low battery
      const isLowBattery = isTagLowBattery(tag);
      if (isLowBattery) {
        setActiveStep('tagLowBattery');
        return;
      }

      // If already paired, follow default behavior
      if (assetId) {
        pOnChange(evt);
        setActiveStep('tagPaired');
      } else {
        pOnChange(evt);
      }
    } catch (err) {
      // If there's an unexpected error, go to the default error screen
      setActiveStep('pairingError');
    }
  }, [pOnChange, assetId, setActiveStep, eventData, tag]);
  return /*#__PURE__*/_jsx(List.Item, {
    className: S.listItem,
    item: tag.id,
    onClick: onClick,
    children: /*#__PURE__*/_jsxs(Flex, {
      variant: "rowM",
      align: "baseline",
      children: [/*#__PURE__*/_jsx("i", {
        className: "fa fa-fw fa-search"
      }), /*#__PURE__*/_jsxs(Flex, {
        variant: "colS",
        children: [/*#__PURE__*/_jsx(Text, {
          children: name
        }), assetId && /*#__PURE__*/_jsx(Text, {
          variant: "pairingErrorSubtitle",
          children: t('alreadyPaired', {
            blueprintName: relationship.blueprint.name
          })
        })]
      })]
    })
  }, tag.id);
}
export default {
  id: 'pairing.imagine.tag.pair.TagPairingSelectionRenderer',
  sort: 'a',
  component: TagPairingSelectionRenderer,
  matches: {
    actionType: 'pair',
    objectType: 'tag'
  }
};